// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.patient-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.patient-form__section {
  box-sizing: border-box;
  padding: 24px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
}

.patient-form__section-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E2E8F0;
}

.patient-form__section-title-row {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.patient-form__section-icon {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #BAE6FD;
  background: #E0F2FE;
  color: #0284C7;
  flex-shrink: 0;
}

.patient-form__section-title {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #0F172A;
  line-height: 1.3;
}

.patient-form__section-subtitle {
  margin: 2px 0 0;
  font-size: 12px;
  color: #64748B;
  line-height: 1.4;
}

.patient-form__section-badge {
  font-size: 11px;
  font-weight: 600;
  color: #64748B;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  white-space: nowrap;
  padding-top: 6px;
}

.patient-form__grid {
  display: grid;
  gap: 16px 24px;
}

.patient-form__grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-bottom: 16px;
}

.patient-form__grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.patient-form__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.patient-form__field--full {
  grid-column: 1 / -1;
}

.patient-form__label {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #0F172A;
  line-height: 1.3;
}

.patient-form__req {
  color: #EF4444;
}

.patient-form__optional {
  margin-inline-start: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #64748B;
}

.patient-form .ant-form-item {
  margin-bottom: 0 !important;
  line-height: normal !important;
  font-size: 13px !important;
}

.patient-form .ant-form-item-label {
  display: none;
  padding: 0 !important;
}

.patient-form .ant-form-item-control-input {
  min-height: 36px !important;
}

.patient-form .ant-form-item-explain-error {
  font-size: 12px;
  margin-top: 4px;
}

/* Single chrome surface: affix/picker/select wrappers own the border.
   Form.Item hasFeedback wraps Input in ant-input-affix-wrapper. */
.patient-form .ant-input-affix-wrapper,
.patient-form .ant-input-affix-wrapper-lg,
.patient-form .ant-picker,
.patient-form .ant-select-selector {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  border-radius: 6px !important;
  border: 1px solid #CBD5E1 !important;
  font-size: 13px !important;
  color: #0F172A !important;
  box-shadow: none !important;
  background: #fff !important;
}

.patient-form .ant-input-affix-wrapper,
.patient-form .ant-input-affix-wrapper-lg {
  /* Kill Ant's 6.5px / 10.5px vertical padding on forced 36px height */
  padding: 0 12px !important;
  display: inline-flex !important;
  align-items: center !important;
  width: 100%;
}

/* Standalone inputs (no affix) */
.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {
  box-sizing: border-box !important;
  height: 36px !important;
  min-height: 36px !important;
  margin: 0 !important;
  padding: 6px 12px !important;
  border-radius: 6px !important;
  border: 1px solid #CBD5E1 !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
  box-shadow: none !important;
  background: #fff !important;
}

/* Inner field must be borderless — otherwise a second box appears inside the wrapper */
.patient-form .ant-input-affix-wrapper input.ant-input,
.patient-form .ant-input-affix-wrapper-lg input.ant-input {
  box-sizing: border-box !important;
  height: 100% !important;
  min-height: 0 !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: none !important;
  border-radius: 0 !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent !important;
  font-size: 13px !important;
  font-weight: 400 !important;
  line-height: 1.5 !important;
  color: #0F172A !important;
}

.patient-form .ant-picker.input-border,
.patient-form .ant-picker {
  padding: 0 11px !important;
  display: flex !important;
  align-items: center !important;
}

.patient-form .ant-picker-input {
  display: flex !important;
  align-items: center !important;
  width: 100%;
  height: 100%;
}

.patient-form .ant-picker-input > input {
  font-size: 13px !important;
  line-height: 1.5 !important;
  height: auto !important;
  padding: 0 !important;
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

.patient-form input.ant-input::placeholder,
.patient-form .ant-picker-input > input::placeholder {
  color: #94A3B8 !important;
  opacity: 1 !important;
  line-height: inherit !important;
}

.patient-form .ant-select-selection-item,
.patient-form .ant-select-selection-placeholder {
  line-height: 34px !important;
  display: flex !important;
  align-items: center !important;
}

/* Feedback icons reserve space — show only on error/success */
.patient-form .ant-form-item-feedback-icon,
.patient-form .ant-input-affix-wrapper .ant-input-suffix {
  display: none !important;
}

.patient-form .ant-form-item-has-error .ant-form-item-feedback-icon,
.patient-form .ant-form-item-has-success .ant-form-item-feedback-icon,
.patient-form .ant-form-item-has-error .ant-input-affix-wrapper .ant-input-suffix,
.patient-form .ant-form-item-has-success .ant-input-affix-wrapper .ant-input-suffix {
  display: inline-flex !important;
  align-items: center !important;
}

.patient-form .ant-form-item-has-error .ant-input-affix-wrapper,
.patient-form .ant-form-item-has-success .ant-input-affix-wrapper,
.patient-form .ant-form-item-has-error .ant-picker,
.patient-form .ant-form-item-has-success .ant-picker,
.patient-form .ant-form-item-has-error .ant-select-selector,
.patient-form .ant-form-item-has-success .ant-select-selector {
  padding-inline-end: 30px !important;
}

.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,
.patient-form .ant-input-affix-wrapper:hover,
.patient-form .ant-picker:hover,
.patient-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
  border-color: #94A3B8 !important;
}

.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,
.patient-form .ant-form-item-control-input-content > input.ant-input-focused:not(textarea),
.patient-form .ant-input-affix-wrapper-focused,
.patient-form .ant-input-affix-wrapper:focus-within,
.patient-form .ant-picker-focused,
.patient-form .ant-select-focused .ant-select-selector {
  border-color: #0EA5E9 !important;
  box-shadow: 0 0 0 1px #0EA5E9 !important;
}

.patient-form .ant-input-affix-wrapper input.ant-input:focus,
.patient-form .ant-input-affix-wrapper input.ant-input-focused {
  border: none !important;
  box-shadow: none !important;
  outline: none !important;
}

.patient-form textarea.ant-input {
  height: auto !important;
  min-height: 84px !important;
  max-height: none !important;
  padding: 10px 12px !important;
  line-height: 1.45 !important;
  resize: vertical;
  border-radius: 6px !important;
  border-color: #CBD5E1 !important;
  font-size: 13px !important;
}

.patient-form .ant-select-single .ant-select-selector {
  display: flex !important;
  align-items: center;
  padding-inline: 11px !important;
}

.patient-form .ant-picker {
  width: 100%;
  padding-inline: 11px !important;
}

.patient-form__checks {
  display: flex;
  flex-wrap: wrap;
  gap: 16px 28px;
}

.patient-form__checks .ant-checkbox-wrapper {
  font-size: 13px;
  color: #0F172A;
}

@media (max-width: 900px) {
  .patient-form__grid--3 {
    grid-template-columns: 1fr;
  }

  .patient-form__grid--2 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/forms/patients/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;kEACkE;AAClE;;;;EAIE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;;EAEE,qEAAqE;EACrE,0BAA0B;EAC1B,+BAA+B;EAC/B,8BAA8B;EAC9B,WAAW;AACb;;AAEA,iCAAiC;AACjC;EACE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,uFAAuF;AACvF;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,kCAAkC;EAClC,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,qBAAqB;EACrB,uBAAuB;EACvB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA,8DAA8D;AAC9D;;EAEE,wBAAwB;AAC1B;;AAEA;;;;EAIE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;;;EAME,mCAAmC;AACrC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;;;EAME,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,6BAA6B;EAC7B,4BAA4B;EAC5B,gBAAgB;EAChB,6BAA6B;EAC7B,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".patient-form {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.patient-form__section {\n  box-sizing: border-box;\n  padding: 24px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n}\n\n.patient-form__section-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding-bottom: 14px;\n  margin-bottom: 20px;\n  border-bottom: 1px solid #E2E8F0;\n}\n\n.patient-form__section-title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  min-width: 0;\n}\n\n.patient-form__section-icon {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #BAE6FD;\n  background: #E0F2FE;\n  color: #0284C7;\n  flex-shrink: 0;\n}\n\n.patient-form__section-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.patient-form__section-subtitle {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #64748B;\n  line-height: 1.4;\n}\n\n.patient-form__section-badge {\n  font-size: 11px;\n  font-weight: 600;\n  color: #64748B;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  white-space: nowrap;\n  padding-top: 6px;\n}\n\n.patient-form__grid {\n  display: grid;\n  gap: 16px 24px;\n}\n\n.patient-form__grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-bottom: 16px;\n}\n\n.patient-form__grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.patient-form__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n}\n\n.patient-form__field--full {\n  grid-column: 1 / -1;\n}\n\n.patient-form__label {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0F172A;\n  line-height: 1.3;\n}\n\n.patient-form__req {\n  color: #EF4444;\n}\n\n.patient-form__optional {\n  margin-inline-start: 4px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #64748B;\n}\n\n.patient-form .ant-form-item {\n  margin-bottom: 0 !important;\n  line-height: normal !important;\n  font-size: 13px !important;\n}\n\n.patient-form .ant-form-item-label {\n  display: none;\n  padding: 0 !important;\n}\n\n.patient-form .ant-form-item-control-input {\n  min-height: 36px !important;\n}\n\n.patient-form .ant-form-item-explain-error {\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n/* Single chrome surface: affix/picker/select wrappers own the border.\n   Form.Item hasFeedback wraps Input in ant-input-affix-wrapper. */\n.patient-form .ant-input-affix-wrapper,\n.patient-form .ant-input-affix-wrapper-lg,\n.patient-form .ant-picker,\n.patient-form .ant-select-selector {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  border-radius: 6px !important;\n  border: 1px solid #CBD5E1 !important;\n  font-size: 13px !important;\n  color: #0F172A !important;\n  box-shadow: none !important;\n  background: #fff !important;\n}\n\n.patient-form .ant-input-affix-wrapper,\n.patient-form .ant-input-affix-wrapper-lg {\n  /* Kill Ant's 6.5px / 10.5px vertical padding on forced 36px height */\n  padding: 0 12px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  width: 100%;\n}\n\n/* Standalone inputs (no affix) */\n.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea) {\n  box-sizing: border-box !important;\n  height: 36px !important;\n  min-height: 36px !important;\n  margin: 0 !important;\n  padding: 6px 12px !important;\n  border-radius: 6px !important;\n  border: 1px solid #CBD5E1 !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n  box-shadow: none !important;\n  background: #fff !important;\n}\n\n/* Inner field must be borderless — otherwise a second box appears inside the wrapper */\n.patient-form .ant-input-affix-wrapper input.ant-input,\n.patient-form .ant-input-affix-wrapper-lg input.ant-input {\n  box-sizing: border-box !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  border: none !important;\n  border-radius: 0 !important;\n  outline: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n  font-size: 13px !important;\n  font-weight: 400 !important;\n  line-height: 1.5 !important;\n  color: #0F172A !important;\n}\n\n.patient-form .ant-picker.input-border,\n.patient-form .ant-picker {\n  padding: 0 11px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n.patient-form .ant-picker-input {\n  display: flex !important;\n  align-items: center !important;\n  width: 100%;\n  height: 100%;\n}\n\n.patient-form .ant-picker-input > input {\n  font-size: 13px !important;\n  line-height: 1.5 !important;\n  height: auto !important;\n  padding: 0 !important;\n  border: none !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.patient-form input.ant-input::placeholder,\n.patient-form .ant-picker-input > input::placeholder {\n  color: #94A3B8 !important;\n  opacity: 1 !important;\n  line-height: inherit !important;\n}\n\n.patient-form .ant-select-selection-item,\n.patient-form .ant-select-selection-placeholder {\n  line-height: 34px !important;\n  display: flex !important;\n  align-items: center !important;\n}\n\n/* Feedback icons reserve space — show only on error/success */\n.patient-form .ant-form-item-feedback-icon,\n.patient-form .ant-input-affix-wrapper .ant-input-suffix {\n  display: none !important;\n}\n\n.patient-form .ant-form-item-has-error .ant-form-item-feedback-icon,\n.patient-form .ant-form-item-has-success .ant-form-item-feedback-icon,\n.patient-form .ant-form-item-has-error .ant-input-affix-wrapper .ant-input-suffix,\n.patient-form .ant-form-item-has-success .ant-input-affix-wrapper .ant-input-suffix {\n  display: inline-flex !important;\n  align-items: center !important;\n}\n\n.patient-form .ant-form-item-has-error .ant-input-affix-wrapper,\n.patient-form .ant-form-item-has-success .ant-input-affix-wrapper,\n.patient-form .ant-form-item-has-error .ant-picker,\n.patient-form .ant-form-item-has-success .ant-picker,\n.patient-form .ant-form-item-has-error .ant-select-selector,\n.patient-form .ant-form-item-has-success .ant-select-selector {\n  padding-inline-end: 30px !important;\n}\n\n.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea):hover,\n.patient-form .ant-input-affix-wrapper:hover,\n.patient-form .ant-picker:hover,\n.patient-form .ant-select:not(.ant-select-disabled):hover .ant-select-selector {\n  border-color: #94A3B8 !important;\n}\n\n.patient-form .ant-form-item-control-input-content > input.ant-input:not(textarea):focus,\n.patient-form .ant-form-item-control-input-content > input.ant-input-focused:not(textarea),\n.patient-form .ant-input-affix-wrapper-focused,\n.patient-form .ant-input-affix-wrapper:focus-within,\n.patient-form .ant-picker-focused,\n.patient-form .ant-select-focused .ant-select-selector {\n  border-color: #0EA5E9 !important;\n  box-shadow: 0 0 0 1px #0EA5E9 !important;\n}\n\n.patient-form .ant-input-affix-wrapper input.ant-input:focus,\n.patient-form .ant-input-affix-wrapper input.ant-input-focused {\n  border: none !important;\n  box-shadow: none !important;\n  outline: none !important;\n}\n\n.patient-form textarea.ant-input {\n  height: auto !important;\n  min-height: 84px !important;\n  max-height: none !important;\n  padding: 10px 12px !important;\n  line-height: 1.45 !important;\n  resize: vertical;\n  border-radius: 6px !important;\n  border-color: #CBD5E1 !important;\n  font-size: 13px !important;\n}\n\n.patient-form .ant-select-single .ant-select-selector {\n  display: flex !important;\n  align-items: center;\n  padding-inline: 11px !important;\n}\n\n.patient-form .ant-picker {\n  width: 100%;\n  padding-inline: 11px !important;\n}\n\n.patient-form__checks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 16px 28px;\n}\n\n.patient-form__checks .ant-checkbox-wrapper {\n  font-size: 13px;\n  color: #0F172A;\n}\n\n@media (max-width: 900px) {\n  .patient-form__grid--3 {\n    grid-template-columns: 1fr;\n  }\n\n  .patient-form__grid--2 {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
